import {Action, Dispatch} from "@reduxjs/toolkit"
import {STANDARD_TEMPLATE} from "@manifest/constants"
import {TemplateSettingsModel} from "../../models/templates"

export const SET_PS_TEMPLATE = "SET_PS_TEMPLATE"

interface SetTemplateAction {
    type: typeof SET_PS_TEMPLATE
    mainTemplate: string
    fallbackTemplate: string
}

export type TemplateSettingsStateModel = TemplateSettingsModel

export const initialTemplateState = {mainTemplate: STANDARD_TEMPLATE, fallbackTemplate: STANDARD_TEMPLATE}

export const setTemplateAction = (mainTemplate: string, fallbackTemplate: string): SetTemplateAction => {
    return {
        type: SET_PS_TEMPLATE,
        mainTemplate,
        fallbackTemplate,
    }
}

const reducer = (state: TemplateSettingsStateModel = initialTemplateState, action: SetTemplateAction) => {
    switch (action.type) {
        case SET_PS_TEMPLATE:
            return {mainTemplate: action.mainTemplate, fallbackTemplate: action.fallbackTemplate}
        default:
            return state
    }
}

export const updateProductSummaryTemplate = (dispatch: Dispatch<Action>, templateSettings: TemplateSettingsModel) => {
    dispatch(setTemplateAction(templateSettings.mainTemplate, templateSettings.fallbackTemplate))
}

export default reducer
